import { createContext, useContext } from 'react';
import type { WsConnectionState } from '../../lib/ws-client.js';

export interface LiveDataState {
  readonly connection: WsConnectionState;
}

export const LiveDataContext = createContext<LiveDataState>({ connection: 'connecting' });

export function useLiveData(): LiveDataState {
  return useContext(LiveDataContext);
}
